export default "__VITE_ASSET__CSP$V9$i__"